export default __webpack_public_path__ + "static/media/Audio-Number-10.9a7ca980.mp3";